import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from "../components/api.js";  // Assure-toi d'importer ton fichier API
import Header from "../components/Header.js";
import '../CSS/seeMore.css';

const SeeMore = () => {
    const { id } = useParams();  // Utilisation de useParams pour récupérer l'ID de l'URL
    const [menuItemId, setMenuItemId] = useState(null);
    const [err, setErr] = useState('');
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Remplacez {id} par la valeur de l'ID récupéré
        setLoading(true);  // Commence le chargement dès que la requête commence
        api.get(`/see_more/${id}`)
            .then(response => {
                setMenuItemId(response.data);
                setLoading(false);  // Arrête le chargement une fois les données récupérées
            })
            .catch(err => {
                setErr('Erreur de la récupération du menu');
                setLoading(false);  // Arrête le chargement même en cas d'erreur
                console.log(err);
            });
    }, [id]);  // Le useEffect se déclenche à chaque fois que `id` change

    if (err) return <div>{err}</div>;

    const handleSubmit = (e) => {
        e.preventDefault();

        // Vérification de la quantité (doit être supérieure à 0)
        if (quantity <= 0 || isNaN(quantity)) {
            alert('Veuillez entrer une quantité valide.');
            return;
        }

        const orderData = {
            itemId: menuItemId.id,
            name: menuItemId.name,
            quantity: quantity,  // Utilise la quantité définie par l'utilisateur
            price: (menuItemId.price * quantity),  // Calcul du prix total
        };

        setLoading(true);  // Démarre le chargement pour la soumission

        api.post('/place_order', orderData)
            .then(response => {
                setLoading(false);  // Arrête le chargement une fois la commande réussie
                alert('Commande passée avec succès !');
            })
            .catch(err => {
                setLoading(false);  // Arrête le chargement en cas d'erreur
                console.log('Erreur lors de la commande', err);
                alert('Erreur lors de la commande');
            });
    };

    return (
        <>
            <Header />

            <div className="container d-flex align-items-center mt-5 bprincipal">
                {loading ? (
                    <div className='d-flex justify-content-center border border-danger'>Chargement...</div>
                ) : (
                    <div className='bprincipal1'>
                        {menuItemId ? (
                            <>
                                <div className='d-flex justify-content-evenly sbloc1'>
                                    <div className='d-flex align-items-center img1'>
                                        <img src="/images/COMMANDO.png" className='img11' alt={menuItemId.name} />
                                    </div>
                                    <div className='border d-flex justify-content-center align-items-center'>
                                        <div>
                                            <div className='d-flex justify-content-center border bg-primary text-white'>
                                                <span className='h2'>{menuItemId.name}</span>
                                            </div>
                                            <br />
                                            <div className='d-flex'>
                                                <span className=''>Prix : {menuItemId.price}</span>
                                            </div>
                                            <div className='d-flex'>
                                                <span className=''>Description : {menuItemId.description}</span>
                                            </div>
                                            <div className='d-flex'>
                                                <span className=''>Disponibilité : </span>
                                                <span>
                                                    {menuItemId.available ? (
                                                        <div className='bg-success text-white'>Disponible</div>
                                                    ) : (
                                                        <div className='bg-danger text-white'>Indisponible</div>
                                                    )}
                                                </span>
                                            </div>
                                            <div className='d-flex'>
                                                <span className=''>Temps De Livraison : 10 min Chrono</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Formulaire de commande */}
                                <form onSubmit={handleSubmit}>
                                    <div className="mt-4">
                                        <label htmlFor="quantity" className="form-label">Quantité</label>
                                        <input
                                            type="number"
                                            id="quantity"
                                            className="form-control"
                                            value={quantity}
                                            onChange={(e) => setQuantity(Number(e.target.value))}
                                            min="1"
                                        />
                                    </div>

                                    {/* Bouton de soumission du formulaire */}
                                    <div className='mt-4 d-flex justify-content-center align-items-center sbloc12'>
                                        <button
                                            type="submit"
                                            className='btn btn-warning btn-lg'
                                            disabled={loading}  // Désactive le bouton pendant le chargement
                                        >
                                            {loading ? 'Commande en cours...' : 'COMMANDER'}
                                        </button>
                                    </div>
                                </form>
                            </>
                        ) : (
                            <div className='d-flex justify-content-center border border-danger'>Chargement des informations...</div>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default SeeMore;
